import {
  APPLICATION_MODULE,
  AUTHORIZED_MODULE,
  FILTER_TEMPLATE_MODULE,
  INFORMATION_LOG_MODULE,
  INFORMATION_SCREEN_WRAPPER, NOTIFICATION, REGION_REGISTRY_MODULE,
  SETTINGS_MODULE,
  SYSTEM_MODULE, USER_MODULE,
  VIOLATIONS_MODULE,
} from '../configs/moduleNames';

import System from './System';
import Authorized from './Authorized';
import Notifications from './Notifications';
import Violation from './Violations';
import Application from './Application';
import Settings from './Settings';
import InformationScreenWrapper from './InformationScreenWrapper';
import FilterTemplate from './FilterTemplate';
import InformationLog from './InformationLog';
import RegionRegistry from './RegionRegistry';
import User from './User';

const modules = {
  [SYSTEM_MODULE]: System,
  [AUTHORIZED_MODULE]: Authorized,
  [USER_MODULE]: User,
  [NOTIFICATION]: Notifications,
  [APPLICATION_MODULE]: Application,
  [NOTIFICATION]: Notifications,
  [REGION_REGISTRY_MODULE]: RegionRegistry,
  [VIOLATIONS_MODULE]: Violation,
  [INFORMATION_LOG_MODULE]: InformationLog,
  [SETTINGS_MODULE]: Settings,
  [INFORMATION_SCREEN_WRAPPER]: InformationScreenWrapper,
  [FILTER_TEMPLATE_MODULE]: FilterTemplate,
};

export default modules;
